import { SvgIcon, SvgIconProps } from '@mui/material';

export const DTVideoCameraIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="21"
    height="21"
    viewBox="0 0 21 21"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.58491 5.54074V13.5333C1.58491 14.0441 1.79363 14.534 2.16517 14.8952C2.5367 15.2564 3.04061 15.4593 3.56604 15.4593H14.5613V11.8617C14.5611 11.8522 14.5611 11.8427 14.5613 11.8332V9.16679C14.5611 9.1573 14.5611 9.14781 14.5613 9.13834V7.46667C14.5613 6.95588 14.3526 6.46601 13.9811 6.10483C13.6095 5.74365 13.1056 5.54074 12.5802 5.54074H1.58491ZM16.1462 7.82437V7.46667C16.1462 6.54725 15.7705 5.66549 15.1018 5.01536C14.433 4.36524 13.526 4 12.5802 4H1.48585C1.09178 4 0.713846 4.15218 0.435195 4.42307C0.156544 4.69395 0 5.06135 0 5.44444V13.5333C0 14.4528 0.375707 15.3345 1.04447 15.9846C1.71323 16.6348 2.62027 17 3.56604 17H14.6604C15.0544 17 15.4324 16.8478 15.711 16.5769C15.9897 16.306 16.1462 15.9386 16.1462 15.5556V13.1756L19.8144 15.2133C20.0596 15.3496 20.361 15.3486 20.6053 15.2107C20.8496 15.0729 21 14.8191 21 14.5444V6.45556C21 6.18094 20.8496 5.92709 20.6053 5.78925C20.361 5.65142 20.0596 5.65044 19.8144 5.78669L16.1462 7.82437ZM16.1462 9.59892V11.4011L19.4151 13.217V7.78304L16.1462 9.59892Z"
    />
  </SvgIcon>
);
